
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11684',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11684",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.451",
  "dashboard-client-types": "static-1.263",
  "data-fetching-client": "static-1.9519",
  "foundations-components": "static-1.7607",
  "foundations-components-legacy": "static-1.632",
  "foundations-theming": "static-1.4253",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7848",
  "hub-http-shared-msw-handlers": "static-1.9574",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11283",
  "I18n": "static-7.1583",
  "jasmine-runner": "static-1.6312",
  "marketplace-storefront-base": "static-1.11744",
  "quartz": "static-1.6789",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16492",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2705",
  "reporting-testing-lib": "static-1.8638",
  "settings-ui-lib": "static-1.12365",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6812",
  "ui-addon-i18n": "static-1.10986",
  "ui-addon-react-router-dom": "static-1.9387",
  "unified-auth": "static-1.272",
  "unified-auth-core-lib": "static-1.553",
  "usage-tracker": "static-1.7177",
  "usage-tracker-core": "static-1.7027",
  "customer-data-property-utils": "static-1.7921",
  "history": "static-4.47",
  "hub-http": "static-1.6059",
  "integrations-lib": "static-1.15562",
  "marketplace-ui-common": "static-1.19065",
  "property-management-iframe": "static-1.12512",
  "quartz-config": "static-1.567",
  "quartz-core": "static-1.6008",
  "quartz-routing": "static-1.219",
  "quick-fetch": "static-1.3778",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4480",
  "ts-schema": "static-1.3945",
  "ui-universal-auth": "static-1.8758",
  "UIComponents": "static-3.8230",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3268",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3066",
  "quartz-webpack": "static-1.3013",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3876",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4681",
  "foundations-theming-specialty": "static-1.1969",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9268",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5214",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1329",
  "ui-fonts": "static-1.545",
  "ui-images": "static-2.1108",
  "bend-plugin-foundations-theming": "static-1.2736",
  "foundations-theming-base": "static-1.3238",
  "stylex": "static-1.28",
  "HeadJS": "static-2.721",
  "hs-test-utils-bend-plugin": "static-1.2959",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4168",
  "ai-components-ui-library": "static-1.8467",
  "ai-rendering-library": "static-1.9432",
  "chirp-fetch": "static-1.1724",
  "connections-embed-lib": "static-1.697",
  "copilot-toolkit": "static-1.10639",
  "laboratory-lib": "static-3.7001",
  "marketplace-embed": "static-1.21582",
  "marketplace-ui-details": "static-1.8961",
  "marketplace-ui-reviews": "static-1.19021",
  "marketplace-ui-tracking": "static-1.13236",
  "sanitize-text": "static-1.7987",
  "ui-addon-video-player": "static-1.8538",
  "usage-tracker-multi": "static-1.5591",
  "usage-tracker-session-replay": "static-1.4863",
  "wootric-nps": "static-1.6825",
  "apollo-link-hub-http": "static-2.4493",
  "immer": "static-1.33",
  "immerable": "static-1.3996",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2389",
  "reporting-data": "static-1.66705",
  "cssUtils": "static-1.747",
  "flux-actions": "static-1.314",
  "HubStyle": "static-2.11591",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10053",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10215",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7167",
  "icons": "static-2.628",
  "marketplace-ui-apps-core": "static-1.17598",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4362",
  "foundations-components-test-utils": "static-1.5090",
  "quartz-i18n": "static-1.464",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3572",
  "customer-data-objects": "static-1.7491",
  "property-translator": "static-1.5251",
  "frontend-preferences-client": "static-1.7766",
  "hs-promise-utils": "static-1.5435",
  "hubspot-apollo-client": "static-1.4721",
  "integrations-error-boundary-lib": "static-1.12977",
  "integrations-tracking-lib": "static-1.5431",
  "native-integrations-shared-strings": "static-1.7629",
  "reselect": "static-2.16",
  "sanitize": "static-1.4316",
  "superstore": "static-1.4611",
  "ui-shepherd-react": "static-3.9988",
  "ai-settings-ui-library": "static-1.7574",
  "hub-http-janus": "static-1.806",
  "hubspotter-http": "static-1.4518",
  "immutable-less": "static-1.4496",
  "marketplace-ui-client-types": "static-1.16472",
  "nav-meta": "static-1.29050",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10083",
  "ui-addon-upgrades": "static-9.17716",
  "inbound-db-properties-service-client": "static-1.3713",
  "property-management-common": "static-1.4799",
  "ui-addon-iframeable": "static-1.8889",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.496",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.464",
  "quartz-head": "static-1.454",
  "quartz-test": "static-1.464",
  "quartz-tracking": "static-1.168",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2992",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20498",
  "ContentUtils": "static-1.67746",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2333",
  "customer-data-filters-ui": "static-1.39054",
  "customer-data-objects-ui-components": "static-1.12853",
  "customer-data-reference-ui-components": "static-1.12989",
  "embedded-academy-lib": "static-1.13702",
  "ExportDialog": "static-6.10229",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40762",
  "reporting-snowflake": "static-1.55323",
  "reporting-ui-components": "static-2.63976",
  "reporting-visualizations": "static-1.58781",
  "ui-addon-teams": "static-1.21297",
  "magpie-lib": "static-1.5436",
  "magpie-types": "static-1.4896",
  "simple-logging-lib": "static-1.2892",
  "navigation-components": "static-1.17413",
  "ai-studio-lib": "static-1.11109",
  "developer-experience-shared-components": "static-1.10336",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7834",
  "ui-tool-access": "static-1.9986",
  "usage-based-billing-components-lib": "static-1.8125",
  "usage-tracker-anonymous": "static-1.5594",
  "usage-tracker-public": "static-1.6988",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3460",
  "persist-promise": "static-1.3550",
  "reference-resolvers": "static-1.8004",
  "ui-extensibility-client-types": "static-1.3785",
  "hubspot-apollo-cache": "static-1.180",
  "universal-page-editor-lib": "static-1.2841",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2297",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4912",
  "purchase-motions-components": "static-1.5535",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1393",
  "crm-component-utils": "static-1.38581",
  "crm-properties-common-lib": "static-1.5714",
  "customer-data-properties": "static-1.50892",
  "framework-data-schema-resolvers": "static-1.6715",
  "property-value-citations": "static-1.1506",
  "reference-resolvers-lite": "static-1.7924",
  "navigation-messaging": "static-1.6740",
  "hubspotter-http-shared-msw-handlers": "static-1.9572",
  "cms-field-types": "static-1.4650",
  "content-icons-ui": "static-1.2171",
  "conversations-skeleton-state": "static-1.7090",
  "crm-message-bus": "static-1.42488",
  "customer-data-filters-ui-msw-helpers": "static-1.21489",
  "customer-data-ui-utilities": "static-1.9666",
  "FormUrlGenerator": "static-2.4563",
  "framework-builder-read-service-client": "static-1.3873",
  "framework-data-schema-quick-fetch": "static-1.6620",
  "multi-account-reference-resolvers": "static-1.816",
  "onboarding-tours": "static-1.16322",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13181",
  "academy-common-lib": "static-1.13162",
  "content-assistance-lib": "static-1.7509",
  "dashboard-lib": "static-1.80801",
  "file-manager-components": "static-1.23025",
  "getting-started-shared-tasks": "static-1.18000",
  "hubspot-prosemirror": "static-1.17717",
  "hubspot-prosemirror-plugins": "static-1.17709",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19541",
  "share-with-third-party-component-lib": "static-1.8535",
  "ui-addon-draggable": "static-3.4609",
  "ui-asset-management-lib": "static-1.10765",
  "ui-business-units-lib": "static-1.8873",
  "user-context": "static-1.4942",
  "growth-payments-core": "static-1.24846",
  "reporting-plugins": "static-1.10029",
  "reporting-reports": "static-1.66383",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.567",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28949",
  "react-codemirror": "static-1.10468",
  "apps-service-types": "static-1.3719",
  "oauth-service-types": "static-1.4089",
  "onboarding-scopes": "static-1.6305",
  "onboarding-tours-client": "static-1.4536",
  "platform-infra-nav-components": "static-1.7531",
  "subscription-experience-data-types": "static-1.14635",
  "crm-record-cards-service-types": "static-1.3481",
  "location-customization-utils-lib": "static-1.8693",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4341",
  "nav-client-types": "static-1.2199",
  "purchase-motions-api": "static-1.5538",
  "signup-constants": "static-1.18505",
  "signup-ui-url-generator": "static-2.7876",
  "trials-service-types": "static-1.3742",
  "card-properties-lib": "static-1.43645",
  "commerce-subscription-lib": "static-1.36580",
  "crm-actions": "static-1.6148",
  "crm-cards-sdk": "static-1.43047",
  "customer-data-properties-shared-msw-handlers": "static-1.8901",
  "customer-data-tracking": "static-1.6724",
  "hs-entities": "static-1.524",
  "pulse": "static-1.359",
  "calling-global-api": "static-1.63820",
  "calling-internal-common": "static-1.31140",
  "calling-lifecycle-internal": "static-1.65202",
  "calling-lifecycle-messages": "static-1.57496",
  "commerce-products-lib": "static-1.8970",
  "conditional-properties-service-client": "static-1.3663",
  "crm-links": "static-1.6109",
  "external-options-client-types": "static-1.4024",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4088",
  "meetings-icalendar-utils-lib": "static-1.474",
  "multi-currency-client-types": "static-1.3556",
  "object-builder-ui-client": "static-1.48138",
  "pipeline-validation-client-types": "static-1.3829",
  "smart-property-lib": "static-1.6103",
  "tiered-pricing": "static-1.891",
  "ui-addon-form-validation": "static-1.10835",
  "crm-pipelines-api-client-types": "static-1.4005",
  "react-dnd-compat": "static-1.4462",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5200",
  "growth-onboarding-confetti": "static-1.2914",
  "growth-onboarding-next-action-utils": "static-1.1405",
  "onboarding-tours-utils": "static-1.388",
  "ui-shepherd-tracker": "static-1.7369",
  "academy-service-client": "static-1.3522",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28055",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8227",
  "video-components-external": "static-1.10692",
  "video-data-lib": "static-1.34350",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23052",
  "ui-addon-emoji-picker": "static-1.9729",
  "EmailSignatureEditor": "static-1.23979",
  "viral-links-lib": "static-1.6880",
  "data-token-picker": "static-1.16113",
  "FileManagerLib": "static-1.38665",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5086",
  "getting-started-shared-tasks-store": "static-1.17118",
  "campaign-roi-lib": "static-1.8412",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.234",
  "eligibility-engine-service-types": "static-1.3023",
  "crm_data": "static-4.91384",
  "customer-data-sidebar": "static-2.45528",
  "enrichment-properties-lib": "static-1.15221",
  "commerce-billing-lib": "static-1.18608",
  "commerce-shared-components-lib": "static-1.18059",
  "commerce-tools-ui-lib": "static-1.9900",
  "crm-fe-perf": "static-1.22747",
  "directed-graph": "static-1.781",
  "event-emitter": "static-1.789",
  "calling-error-reporting": "static-1.31146",
  "shared-worker-versioning": "static-1.10881",
  "calling-usage-tracker": "static-1.6383",
  "voice-sms-access-library": "static-1.369",
  "commerce-permissions": "static-1.603",
  "products-iframe-lib": "static-1.7442",
  "products-ui-components-shared-msw-handlers": "static-1.9956",
  "breeze-intelligence-kit": "static-1.5382",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9657",
  "policy-lib": "static-1.6619",
  "react-tinymce": "static-1.54738",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9720",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53864",
  "tinymce-plugins": "static-1.56978",
  "tinymce-themes": "static-1.55834",
  "growth-onboarding-next-action-components": "static-1.1433",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6423",
  "content-media-composition-data-lib": "static-1.11595",
  "content-media-compositions": "static-2.15602",
  "media-bridge-lib": "static-1.18635",
  "commerce-tours-lib": "static-1.5781",
  "growth-onboarding-reliability": "static-1.4928",
  "sales-checkout-service-client": "static-1.3509",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21378",
  "sales-email-signature-service-client": "static-1.3685",
  "audio-components": "static-1.5672",
  "FileManagerCore": "static-1.38524",
  "FileManagerImages": "static-1.36176",
  "video-components": "static-1.12695",
  "crm_universal": "static-1.21729",
  "customer-data-email": "static-1.17740",
  "card-payment-highlight-lib": "static-1.36632",
  "card-subscription-highlight-lib": "static-1.39003",
  "commerce-contract-lib": "static-1.11350",
  "customer-data-content": "static-1.26948",
  "invoices-highlight-card-lib": "static-1.54164",
  "orders-highlight-card-lib": "static-1.20973",
  "products-highlight-card-lib": "static-1.17254",
  "project-storage": "static-1.4575",
  "quotes-highlight-card-lib": "static-1.71341",
  "crm-source-interpretation-lib": "static-1.5172",
  "utility-belt": "static-1.2382",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11515",
  "payments-enrollment-embed-lib": "static-1.22136",
  "customer-data-rte": "static-1.32546",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5429",
  "InboxConnectUtils": "static-4.14331",
  "payments-post-enroll-local-storage-lib": "static-1.4956",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37430",
  "calling-orchestration-schema": "static-1.35146",
  "sales-views-client-types": "static-1.4128",
  "hub-http-contrib": "static-1.2885",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39949",
  "ui-addon-sales-email": "static-1.5056",
  "layout-dnd-components": "static-1.12116",
  "layout-dnd-utils": "static-1.11091",
  "ui-brand-identity-lib": "static-1.14177",
  "NamespacedHubStyle": "static-2.8936",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4373",
  "video-embed": "static-1.35184",
  "social-insights-client-types": "static-1.21481",
  "sequences-lib": "static-1.7752",
  "ui-gdpr-components": "static-1.10189",
  "products-ui-components": "static-1.39489",
  "quotes-ui-lib": "static-1.80061",
  "SalesContentIndexUI": "static-3.8964",
  "accounting-integrations-ui-components": "static-1.6792",
  "invoices-ui-lib": "static-1.54180",
  "commerce-products-api": "static-1.2018",
  "SafeStorage": "static-1.4244",
  "invoices-iframe-lib": "static-1.56238",
  "quotes-modal-lib": "static-1.102018",
  "deal-intel-decorators": "static-1.1412",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7207",
  "draft-content-plugins": "static-1.27813",
  "ContentData": "static-1.67821",
  "layout-data-lib": "static-1.9416",
  "outpost": "static-1.4043",
  "sequences-client-types-lib": "static-1.7609",
  "commerce-tax-lib": "static-1.358",
  "property-description-translator": "static-1.3698",
  "FireAlarmUi": "static-1.4373",
  "sales-templates-service-types-lib": "static-1.4032",
  "commerce-analytics-service-client": "static-1.3497",
  "totals-ui-components": "static-1.23102",
  "deal-intel-utils": "static-1.1416",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14878",
  "advanced-menus-lib": "static-1.11848",
  "ui-memberships-settings-lib": "static-1.33563",
  "commerce-totals-service-types": "static-1.3680",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14877",
  "simple-menus-lib": "static-1.16394"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11684",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.451",
  "dashboard-client-types": "/dashboard-client-types/static-1.263",
  "data-fetching-client": "/data-fetching-client/static-1.9519",
  "foundations-components": "/foundations-components/static-1.7607",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.632",
  "foundations-theming": "/foundations-theming/static-1.4253",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7848",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9574",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11283",
  "I18n": "/I18n/static-7.1583",
  "jasmine-runner": "/jasmine-runner/static-1.6312",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11744",
  "quartz": "/quartz/static-1.6789",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16492",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2705",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8638",
  "settings-ui-lib": "/settings-ui-lib/static-1.12365",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6812",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10986",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9387",
  "unified-auth": "/unified-auth/static-1.272",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.553",
  "usage-tracker": "/usage-tracker/static-1.7177",
  "usage-tracker-core": "/usage-tracker-core/static-1.7027",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7921",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6059",
  "integrations-lib": "/integrations-lib/static-1.15562",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19065",
  "property-management-iframe": "/property-management-iframe/static-1.12512",
  "quartz-config": "/quartz-config/static-1.567",
  "quartz-core": "/quartz-core/static-1.6008",
  "quartz-routing": "/quartz-routing/static-1.219",
  "quick-fetch": "/quick-fetch/static-1.3778",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4480",
  "ts-schema": "/ts-schema/static-1.3945",
  "ui-universal-auth": "/ui-universal-auth/static-1.8758",
  "UIComponents": "/UIComponents/static-3.8230",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3268",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3066",
  "quartz-webpack": "/quartz-webpack/static-1.3013",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3876",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4681",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1969",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9268",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5214",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1329",
  "ui-fonts": "/ui-fonts/static-1.545",
  "ui-images": "/ui-images/static-2.1108",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2736",
  "foundations-theming-base": "/foundations-theming-base/static-1.3238",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.721",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2959",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4168",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8467",
  "ai-rendering-library": "/ai-rendering-library/static-1.9432",
  "chirp-fetch": "/chirp-fetch/static-1.1724",
  "connections-embed-lib": "/connections-embed-lib/static-1.697",
  "copilot-toolkit": "/copilot-toolkit/static-1.10639",
  "laboratory-lib": "/laboratory-lib/static-3.7001",
  "marketplace-embed": "/marketplace-embed/static-1.21582",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8961",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19021",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13236",
  "sanitize-text": "/sanitize-text/static-1.7987",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8538",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5591",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4863",
  "wootric-nps": "/wootric-nps/static-1.6825",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4493",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3996",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2389",
  "reporting-data": "/reporting-data/static-1.66705",
  "cssUtils": "/cssUtils/static-1.747",
  "flux-actions": "/flux-actions/static-1.314",
  "HubStyle": "/HubStyle/static-2.11591",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10053",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10215",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7167",
  "icons": "/icons/static-2.628",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17598",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4362",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5090",
  "quartz-i18n": "/quartz-i18n/static-1.464",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3572",
  "customer-data-objects": "/customer-data-objects/static-1.7491",
  "property-translator": "/property-translator/static-1.5251",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7766",
  "hs-promise-utils": "/hs-promise-utils/static-1.5435",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4721",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12977",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5431",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7629",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4316",
  "superstore": "/superstore/static-1.4611",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9988",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7574",
  "hub-http-janus": "/hub-http-janus/static-1.806",
  "hubspotter-http": "/hubspotter-http/static-1.4518",
  "immutable-less": "/immutable-less/static-1.4496",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16472",
  "nav-meta": "/nav-meta/static-1.29050",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10083",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17716",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3713",
  "property-management-common": "/property-management-common/static-1.4799",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8889",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.496",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.464",
  "quartz-head": "/quartz-head/static-1.454",
  "quartz-test": "/quartz-test/static-1.464",
  "quartz-tracking": "/quartz-tracking/static-1.168",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20498",
  "ContentUtils": "/ContentUtils/static-1.67746",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2333",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39054",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12853",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12989",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13702",
  "ExportDialog": "/ExportDialog/static-6.10229",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40762",
  "reporting-snowflake": "/reporting-snowflake/static-1.55323",
  "reporting-ui-components": "/reporting-ui-components/static-2.63976",
  "reporting-visualizations": "/reporting-visualizations/static-1.58781",
  "ui-addon-teams": "/ui-addon-teams/static-1.21297",
  "magpie-lib": "/magpie-lib/static-1.5436",
  "magpie-types": "/magpie-types/static-1.4896",
  "simple-logging-lib": "/simple-logging-lib/static-1.2892",
  "navigation-components": "/navigation-components/static-1.17413",
  "ai-studio-lib": "/ai-studio-lib/static-1.11109",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10336",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7834",
  "ui-tool-access": "/ui-tool-access/static-1.9986",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8125",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5594",
  "usage-tracker-public": "/usage-tracker-public/static-1.6988",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3460",
  "persist-promise": "/persist-promise/static-1.3550",
  "reference-resolvers": "/reference-resolvers/static-1.8004",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3785",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.180",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2841",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2297",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4912",
  "purchase-motions-components": "/purchase-motions-components/static-1.5535",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1393",
  "crm-component-utils": "/crm-component-utils/static-1.38581",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5714",
  "customer-data-properties": "/customer-data-properties/static-1.50892",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6715",
  "property-value-citations": "/property-value-citations/static-1.1506",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7924",
  "navigation-messaging": "/navigation-messaging/static-1.6740",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9572",
  "cms-field-types": "/cms-field-types/static-1.4650",
  "content-icons-ui": "/content-icons-ui/static-1.2171",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7090",
  "crm-message-bus": "/crm-message-bus/static-1.42488",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21489",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9666",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4563",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3873",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6620",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.816",
  "onboarding-tours": "/onboarding-tours/static-1.16322",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13181",
  "academy-common-lib": "/academy-common-lib/static-1.13162",
  "content-assistance-lib": "/content-assistance-lib/static-1.7509",
  "dashboard-lib": "/dashboard-lib/static-1.80801",
  "file-manager-components": "/file-manager-components/static-1.23025",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18000",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17717",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17709",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19541",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8535",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4609",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10765",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8873",
  "user-context": "/user-context/static-1.4942",
  "growth-payments-core": "/growth-payments-core/static-1.24846",
  "reporting-plugins": "/reporting-plugins/static-1.10029",
  "reporting-reports": "/reporting-reports/static-1.66383",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.567",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28949",
  "react-codemirror": "/react-codemirror/static-1.10468",
  "apps-service-types": "/apps-service-types/static-1.3719",
  "oauth-service-types": "/oauth-service-types/static-1.4089",
  "onboarding-scopes": "/onboarding-scopes/static-1.6305",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4536",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7531",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14635",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3481",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8693",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4341",
  "nav-client-types": "/nav-client-types/static-1.2199",
  "purchase-motions-api": "/purchase-motions-api/static-1.5538",
  "signup-constants": "/signup-constants/static-1.18505",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7876",
  "trials-service-types": "/trials-service-types/static-1.3742",
  "card-properties-lib": "/card-properties-lib/static-1.43645",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36580",
  "crm-actions": "/crm-actions/static-1.6148",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43047",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8901",
  "customer-data-tracking": "/customer-data-tracking/static-1.6724",
  "hs-entities": "/hs-entities/static-1.524",
  "pulse": "/pulse/static-1.359",
  "calling-global-api": "/calling-global-api/static-1.63820",
  "calling-internal-common": "/calling-internal-common/static-1.31140",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65202",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57496",
  "commerce-products-lib": "/commerce-products-lib/static-1.8970",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3663",
  "crm-links": "/crm-links/static-1.6109",
  "external-options-client-types": "/external-options-client-types/static-1.4024",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4088",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.474",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3556",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48138",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3829",
  "smart-property-lib": "/smart-property-lib/static-1.6103",
  "tiered-pricing": "/tiered-pricing/static-1.891",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10835",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4005",
  "react-dnd-compat": "/react-dnd-compat/static-1.4462",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5200",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2914",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1405",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.388",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7369",
  "academy-service-client": "/academy-service-client/static-1.3522",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28055",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8227",
  "video-components-external": "/video-components-external/static-1.10692",
  "video-data-lib": "/video-data-lib/static-1.34350",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23052",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9729",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "viral-links-lib": "/viral-links-lib/static-1.6880",
  "data-token-picker": "/data-token-picker/static-1.16113",
  "FileManagerLib": "/FileManagerLib/static-1.38665",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5086",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17118",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8412",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.234",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3023",
  "crm_data": "/crm_data/static-4.91384",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45528",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15221",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18608",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18059",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9900",
  "crm-fe-perf": "/crm-fe-perf/static-1.22747",
  "directed-graph": "/directed-graph/static-1.781",
  "event-emitter": "/event-emitter/static-1.789",
  "calling-error-reporting": "/calling-error-reporting/static-1.31146",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10881",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6383",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.369",
  "commerce-permissions": "/commerce-permissions/static-1.603",
  "products-iframe-lib": "/products-iframe-lib/static-1.7442",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9956",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5382",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9657",
  "policy-lib": "/policy-lib/static-1.6619",
  "react-tinymce": "/react-tinymce/static-1.54738",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9720",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53864",
  "tinymce-plugins": "/tinymce-plugins/static-1.56978",
  "tinymce-themes": "/tinymce-themes/static-1.55834",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1433",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6423",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11595",
  "content-media-compositions": "/content-media-compositions/static-2.15602",
  "media-bridge-lib": "/media-bridge-lib/static-1.18635",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5781",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4928",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3509",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21378",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3685",
  "audio-components": "/audio-components/static-1.5672",
  "FileManagerCore": "/FileManagerCore/static-1.38524",
  "FileManagerImages": "/FileManagerImages/static-1.36176",
  "video-components": "/video-components/static-1.12695",
  "crm_universal": "/crm_universal/static-1.21729",
  "customer-data-email": "/customer-data-email/static-1.17740",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36632",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39003",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11350",
  "customer-data-content": "/customer-data-content/static-1.26948",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54164",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20973",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17254",
  "project-storage": "/project-storage/static-1.4575",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71341",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5172",
  "utility-belt": "/utility-belt/static-1.2382",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11515",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22136",
  "customer-data-rte": "/customer-data-rte/static-1.32546",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5429",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14331",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4956",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37430",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35146",
  "sales-views-client-types": "/sales-views-client-types/static-1.4128",
  "hub-http-contrib": "/hub-http-contrib/static-1.2885",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39949",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5056",
  "layout-dnd-components": "/layout-dnd-components/static-1.12116",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11091",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14177",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8936",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4373",
  "video-embed": "/video-embed/static-1.35184",
  "social-insights-client-types": "/social-insights-client-types/static-1.21481",
  "sequences-lib": "/sequences-lib/static-1.7752",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10189",
  "products-ui-components": "/products-ui-components/static-1.39489",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80061",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8964",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6792",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54180",
  "commerce-products-api": "/commerce-products-api/static-1.2018",
  "SafeStorage": "/SafeStorage/static-1.4244",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56238",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102018",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1412",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7207",
  "draft-content-plugins": "/draft-content-plugins/static-1.27813",
  "ContentData": "/ContentData/static-1.67821",
  "layout-data-lib": "/layout-data-lib/static-1.9416",
  "outpost": "/outpost/static-1.4043",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7609",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.358",
  "property-description-translator": "/property-description-translator/static-1.3698",
  "FireAlarmUi": "/FireAlarmUi/static-1.4373",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4032",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3497",
  "totals-ui-components": "/totals-ui-components/static-1.23102",
  "deal-intel-utils": "/deal-intel-utils/static-1.1416",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14878",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11848",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33563",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3680",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14877",
  "simple-menus-lib": "/simple-menus-lib/static-1.16394"
}
};
